let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("caPo2")).then(() => parcelRequire('9q99Q'));